import { render, staticRenderFns } from "./DetailsList.vue?vue&type=template&id=f3201e2c&scoped=true&lang=pug"
import script from "./DetailsList.vue?vue&type=script&lang=ts"
export * from "./DetailsList.vue?vue&type=script&lang=ts"
import style0 from "./DetailsList.vue?vue&type=style&index=0&id=f3201e2c&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3201e2c",
  null
  
)

export default component.exports